// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Yjje","header":"MessagesList_header__1jdk4","chat":"MessagesList_chat__2UX1Y"};